import React from 'react';
import cl from 'classnames';
import s from './AppBar.css';

function renderItems(items) {
  if (!Array.isArray(items)) {
    return items;
  }

  return items
    .filter(item => Boolean(item))
    .map((item, i) => React.cloneElement(item, {key: `i-${i}`}));
}

function Container({children, type, ...props}) {
  if (type === 'header') {
    return <header {...props}>{children}</header>;
  }

  if (type === 'footer') {
    return <footer {...props}>{children}</footer>;
  }

  return <section {...props}>{children}</section>;
}

const AppBar = ({
  leftElements,
  middleElements,
  rightElements,
  container,
  className,
  style
}) => {
  return (
    <Container
      type={container}
      className={cl(s.OuterContainer, className)}
      style={style}
    >
      {(leftElements || middleElements) && (
        <section className={s.Container}>{renderItems(leftElements)}</section>
      )}
      {middleElements && (
        <section className={cl(s.Middle, s.Container)}>
          {renderItems(middleElements)}
        </section>
      )}
      {(rightElements || middleElements) && (
        <section className={cl(s.Right, s.Container)}>
          {renderItems(rightElements)}
        </section>
      )}
    </Container>
  );
};

export default AppBar;
